import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Typography,
  Box,
  Snackbar,
  Button,
  Badge
} from '@mui/material';

import API from '../services/api';
import { motion } from 'framer-motion';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import ProductCard from './ProductCard';
import CartModal from './CartModal';
import Loader from '../components/loader/loader';
import ParticleBackground from '../components/common/ParticleBackground';

import productImage1 from './assets/products/product1.jpg';
import productImage2 from './assets/products/product2.jpg';
import productImage3 from './assets/products/product3.jpg';
import gorra1 from './assets/products/Gorra_Adelante.png';
import gorra2 from './assets/products/Gorra_Adelante1.png';
//import gorra3 from './assets/products/Gorra_Adelante2.png';
//import pantalon from './assets/products/Pantalon_Frontal.png';
import pantalon2 from './assets/products/Pantalon_Frontal1.png';







const products = [
  { id: 1, name: 'Camiseta Rebel Fox Red Wind', description: 'Camiseta oficial del equipo en edición limitada 2024.', price: 68000, image: productImage1 },
  { id: 2, name: 'Pantalon Rebel Fox', description: 'Pantalon Sky Fox.', price: 75000, image: productImage2 },
  { id: 3, name: 'Chaqueta Rebel Fox', description: 'Chaqueta Full Kill RFG.', price: 110000, image: productImage3 },
  { id: 4, name: 'Gorra Fost Terc', description: 'Gorra oficial del equipo en edición limitada.', price: 35000, image: gorra1 },
  { id: 5, name: 'Gorra Radiant Fox', description: 'Gorra ajustable con el logo del equipo.', price: 35000, image: gorra2 },
  { id: 6, name: 'Pantalon Oficial Black Eyes', description: 'Pantalon Black Eyes.', price: 75000, image: pantalon2 },
];

const Shop = () => {

  const [loading, setLoading] = useState(true);
const [cart, setCart] = useState(() => {
  const savedCart = localStorage.getItem("cart");
  return savedCart ? JSON.parse(savedCart) : [];
});  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [cartModalOpen, setCartModalOpen] = useState(false);

  // =========================
  // 🛒 CART
  // =========================
  const addToCart = (product) => {
    const productInCart = cart.find((item) => item.id === product.id);

    if (productInCart) {
      setCart(cart.map((item) =>
        item.id === product.id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }

    setSnackbarOpen(true);
  };

  const getTotalItems = () =>
    cart.reduce((acc, item) => acc + item.quantity, 0);

  // =========================
  // ⏳ LOADING
  // =========================
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  // =========================
  // 💳 CHECKOUT (LOGIN REQUIRED)
  // =========================
 const handleCheckout = async () => {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Tenés que iniciar sesión para comprar");
      return;
    }

  const formattedItems = cart.map(item => ({
  id: item.id,
  quantity: item.quantity
}));

    const res = await API.post(
      "/payments/create-order",
      { items: formattedItems },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    window.location.href = res.data.init_point;

  } catch (error) {
    console.log(error);
    alert("Error al procesar pago");
  }
};

  useEffect(() => {
  localStorage.setItem("cart", JSON.stringify(cart));
}, [cart]);

  // =========================
  // UI HELPERS
  // =========================
  const handleSnackbarClose = () => setSnackbarOpen(false);
  const handleCartModalOpen = () => setCartModalOpen(true);
  const handleCartModalClose = () => setCartModalOpen(false);

  // =========================
  // LOADING SCREEN
  // =========================
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <Loader />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <ParticleBackground />

      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
          py: { xs: 6, md: 10 }
        }}
      >

        {/* TITLE */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h2"
            sx={{
              color: '#fff',
              textShadow: '0 0 20px rgba(255,110,0,0.6)'
            }}
          >
            Tienda Rebel Fox
          </Typography>
        </Box>

        {/* PRODUCTS */}
        <Grid container spacing={4}>
          {products.map((product) => {
            const productInCart = cart.find((item) => item.id === product.id);
            const quantityInCart = productInCart ? productInCart.quantity : 0;

            return (
              <Grid item xs={12} sm={6} md={4} key={product.id}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <ProductCard
                    product={product}
                    addToCart={addToCart}
                    quantityInCart={quantityInCart}
                  />
                </motion.div>
              </Grid>
            );
          })}
        </Grid>

        {/* CART BUTTON */}
        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Badge badgeContent={getTotalItems()} color="error">
            <Button
              variant="contained"
              startIcon={<ShoppingCartIcon />}
              onClick={handleCartModalOpen}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 'bold',
                background: 'linear-gradient(90deg, #ff6e00, #ffae00)',
                boxShadow: '0 0 15px rgba(255,110,0,0.6)',
                '&:hover': {
                  boxShadow: '0 0 25px rgba(255,110,0,1)'
                }
              }}
            >
              Ver Carrito
            </Button>
          </Badge>

          {/* 💳 BOTÓN DE PAGO (AGREGADO) */}
          <Box sx={{ mt: 3 }}>
            <Button
              variant="outlined"
              color="success"
              disabled={cart.length === 0}
              onClick={handleCheckout}
            >
              Pagar ahora
            </Button>
          </Box>
        </Box>
      </Container>

      

      {/* MODAL */}
      <CartModal
  open={cartModalOpen}
  onClose={handleCartModalClose}
  cart={cart}
  setCart={setCart}
  onCheckout={handleCheckout} // 🔥 clave
/>

      {/* SNACKBAR */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message="Producto añadido al carrito"
      />
    </Box>
  );
};


export default Shop;